import React from 'react'

import './market-content.scss'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { pushDataLayerEvent } from '../../../shared/utils/metricManagementUtil'
import { encryptUserInfo } from '../../../shared/utils/encryptUserInfo';

const MarketContent = props => {
    const { mobile, comercio, promocion, subtituloGeneral } = props;
    var settings = {
        infinite: true,
        arrows: false,
        slidesToShow: 1,
        dots: true,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        speed: 1000
    };


    return (
        <div className="f-MarketContent">
            <div >
                {promocion.length > 0 &&
                    <Slider {...settings} className="f-MarketContent-slider-promo">
                        {promocion.map((prom, index) => {
                            return (
                                // defaultChecked = { activeFilters.find(x => x.id === numfilter + index) ? activeFilters.find(x => x.id === numfilter + index).value : false } 

                                <div key={index}>
                                    <div className="f-MarketContent-slider-promo-content">
                                        {documentToReactComponents(prom.descripcion && prom.descripcion.json)}
                                        <img alt={prom.imagen[0].description} src={prom.imagen[0].file.url} />

                                    </div>

                                </div>
                            )
                        }
                        )
                        }

                    </Slider>}
            </div>
            <div className="f-MarketContent-content">
                <p>{subtituloGeneral}</p>
                {comercio.length > 0 &&
                    <div className="f-MarketContent-comercio">
                        {comercio.map((item, index) => {
                            return (
                                // defaultChecked = { activeFilters.find(x => x.id === numfilter + index) ? activeFilters.find(x => x.id === numfilter + index).value : false } 
                                <a
                                    key={index}
                                    rel="noopener noreferrer"
                                    className="f-MarketContent-comercio-item"
                                    href={item.redireccion}
                                    target="_blank"
                                    onClick={
                                        () => {
                                            const urlParams = new URLSearchParams(window.location.search);                                            
                                            const product = urlParams.get('product')
                                            const productUrl = urlParams.get('productUrl')
                                            window.dataLayer = window.dataLayer || []
                                            window.dataLayer.push({
                                                'event': 'gaEvent',
                                                'eventTrigger': 'BIN',
                                                'eventCategory': 'Buy Now - Retailer Click – Page URL',
                                                'eventAction': product, // this variable need to be dynamically pushed
                                                'eventLabel': productUrl, // this variable need to be dynamically pushed
                                                'eventValue': undefined

                                            })
                                            window.dataLayer.push({
                                                'event': 'gaEvent',
                                                'eventTrigger': 'BIN',
                                                'eventCategory': 'Buy Now - Retailer click - Retailer Domain',
                                                'eventAction': product, // this variable need to be dynamically pushed
                                                'eventLabel': item.redireccion.split("/")[2], // this variable need to be dynamically pushed
                                                'eventValue': undefined
                                            });
                                            const userInfoEncrypt = encryptUserInfo()
                                            pushDataLayerEvent({
                                                event: 'Interacciones_Tiendas',
                                                category: 'Tienda',
                                                action: 'click',
                                                label: item.titulo.split('>')[1],
                                                location: window.location.href,
                                                user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
                                                log_status: userInfoEncrypt.log_status,
                                            })
                                        }
                                      }

                                >
                        {!mobile && <img alt={item.imagen[0].description} src={item.imagen[0].file.url} />}
                        {mobile && <img alt={item.imagen[1].description} src={item.imagen[1].file.url} />}
                        <div className="f-MarketContent-comercio-item-hover">
                            <span className="icon-cart"></span>
                            <p>Comprar</p>
                        </div>
                    </a>
                            )
                        }
                )
                        }
            </div>
                }
        </div>
        </div >
    )
}

export default MarketContent
